import axios from '../axios'

/* 
 * 分类模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/address/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/address/delete',
        method: 'post',
        data
    })
}
// 查询
export const findPage = (data) => {
    return axios({
        url: '/address/findPage',
        method: 'post',
        data
    })
}



// 查询
export const findPageAll = (data) => {
    return axios({
        url: '/address/findPageAll',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/address.js